import { adminHttpClient } from '../../commons/adminHttpClient'

const deletePremiumExpense = (premiumId: string): Promise<any> => {
  return adminHttpClient.delete(`/Expenses/DeletePremium/${premiumId}`, '')
}

export default deletePremiumExpense
